export default __webpack_public_path__ + "static/do-align-9e5a2f72655e45be486a08242a7650df.png";